import React from "react";

import errorIcon from "images/tileIcons/error.svg";

import styles from "./style.module.css";

const errorCodes = {
  default: {
    title: "Something went wrong",
    description:
      "An error occurred during the model creation. If the error continues please submit a ticket through our support site for additional help."
  },
  NotEnoughDataToEncode: {
    title: "Not Enough Data",
    description: "Please add more rows to continue the model creation."
  },
  TerminateTrainingError: {
    title: "Unable to complete model training",
    description: "This could be the result of poor quality or insufficient data."
  },
  ProjectNotFound: {
    title: "Unable to find project",
    description: "This project may have been deleted or you may not have access permissions."
  }
};

export default class ModelError extends React.PureComponent {
  renderTitle() {
    const { errors } = this.props;
    if (errors && errors[0] && errorCodes[errors[0].code]) {
      return errorCodes[errors[0].code].title;
    }

    return errorCodes["default"].title;
  }

  renderDescription() {
    const { errors } = this.props;
    if (errors && errors[0] && errorCodes[errors[0].code]) {
      return errorCodes[errors[0].code].description;
    }

    return errorCodes["default"].description;
  }

  render() {
    const { errors, aibleViewType, isNext, isOverallSegment, modelGroups } = this.props;
    //for now, we'll only pass the top as a code title
    if (!errors) {
      return <React.Fragment />;
    }

    if (isNext && isOverallSegment) {
      const erroredDrilldowns = modelGroups.drilldownValues.filter((d) => {
        return d.value !== "Overall" && d.errorMessages?.length;
      });
      if (!erroredDrilldowns?.length) {
        return <React.Fragment />;
      }
      const totalErrors = erroredDrilldowns.reduce((acc, d) => acc + d.errorMessages.length, 0);
      return (
        <div className={styles.errorWrapper + " " + styles.isNext} style={{ height: "unset" }}>
          <div className={styles.modelErrorTitle}>
            {`There ${totalErrors > 1 ? "are" : "is"} ${totalErrors} error${totalErrors === 1 ? "" : "s"} in ${erroredDrilldowns.length} Subgroup${erroredDrilldowns.length === 1 ? "" : "s"}`}
          </div>
          {erroredDrilldowns.map((d, i) => {
            const errorCount = d.errorMessages?.length;
            return (
              <div key={i} className={styles.modelErrors}>
                {`${d.value}: ${errorCount} error${errorCount === 1 ? "" : "s"}`}
              </div>
            );
          })}
        </div>
      );
    }

    return (
      <div
        className={
          styles.errorWrapper +
          (aibleViewType == "Aible Business" ? " " + styles.errorWrapperExtend : "") +
          (isNext ? " " + styles.isNext : "")
        }
      >
        <div className={styles.modelErrorTitle}>{this.renderTitle()}</div>
        {errors.length == 1 ? (
          <div className={styles.modelErrors}>{this.renderDescription()}</div>
        ) : (
          <ul className={styles.modelErrors}>
            {errors.map((item, i) => (
              <li key={i}>{item.message}</li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}
